import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { Select, Spin, Divider } from 'antd'

import { withTranslation } from 'react-i18next'

const SelectSearchOrderPaymentDetail = ({
    defaultValue = undefined,
    loading = false,
    onChange = () => {},
    onSearch = () => {},
    orderPaymentDetails = [],
    value = undefined,
    i18n,
    ...restSelectProps
}) => {
    return (
        <Select
            allowClear
            defaultActiveFirstOption={false}
            defaultValue={_.map(defaultValue, 'id')}
            dropdownRender={(menu) => (
                <div>
                    {menu}

                    {loading &&
                    <>
                        <Divider style={{ margin: '4px 0' }} />

                        <div
                            style={{ textAlign: 'center' }}
                        >
                            <Spin size="small" />
                        </div>
                    </>
                    }
                </div>
            )}
            filterOption={false}
            loading={loading}
            notFoundContent={loading ? <Spin size="small" /> : null}
            onChange={onChange}
            onSearch={onSearch}
            placeholder={i18n.t('confirms:paymentVoucher.searchReceiptVoucher')}
            showArrow={false}
            showSearch
            style={restSelectProps.style || { width: '200px' }}
            mode="multiple"
            {...restSelectProps}
        >
            {orderPaymentDetails.map((orderPaymentDetail, index) => {
                return (
                    <Select.Option
                        key={_.get(orderPaymentDetail, 'id', `index-${index}`)}
                        value={_.get(orderPaymentDetail, 'id', undefined)}
                    >
                        {_.get(orderPaymentDetail, 'external_id', '')}
                    </Select.Option>
                )
            })}
            {defaultValue.map((orderPaymentDetail, index) => {
                return (
                    <Select.Option
                        key={_.get(orderPaymentDetail, 'id', `index-${index}`)}
                        value={_.get(orderPaymentDetail, 'id', undefined)}
                    >
                        {_.get(orderPaymentDetail, 'external_id', '')}
                    </Select.Option>
                )
            })}
        </Select>
    )
}

SelectSearchOrderPaymentDetail.propTypes = {
    defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(undefined)]),
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    orderPaymentDetails: PropTypes.array,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.instanceOf(undefined)])
}

export default withTranslation(['confirms'])(SelectSearchOrderPaymentDetail)
